import { auth } from "@/core/utils/auth0";
import Cookies from "js-cookie";
import { create } from "zustand";
import { useManagementMandateStore } from "../management-mandate";
import { UserProfileType } from "@/types/user";


type UserState = {
  openSidebar: boolean;
  user: UserProfileType;
  accessToken: string;
  toggleSidebar: () => void;
  setUser: (user: any) => void;
  logout: () => void;
};

export const useUserStore = create<UserState>((set, get) => ({
  openSidebar: false,
  user: {
    id: "",
    onboarding: {},
    type: "",
    synapsSessionId: "",
    wantToDoFirstAction: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    referralCode: "",
    username: "",
    address: "",
    zipCode: "",
    city: "",
    email: "",
    avatar: "",
    synapsStatus: "",
    country: "FR",
    isSignedMandateContract: false,
    isVerified: false,
    vigilance: 2,
    totpIsVerified: false,
    fidoEnabled: false,

    // Company infos
    companyName: '',
    companyForm: '',
    companyRegistrationNumber: '',
    beneficiaries: '',
    companyShareCapital: undefined,
    companyTradeRegister: undefined,

    // Individual KYC
    nationality: undefined,
  },
  accessToken: Cookies.get('accessToken') || '',
  toggleSidebar: () => set({ openSidebar:  !get().openSidebar }),
  setUser: (data: any) => set({ user: { ...get().user, ...data } }),
  logout: () => {
    useManagementMandateStore.getState().resetManagementMandate();
    Cookies.remove('accessToken');
    if (auth) {
      auth.logout({
        clientID: import.meta.env.VITE_AUTH0_CLIENT_ID || "znbx1OLiPALggVaAr0SfEvSxTN7BnmJf",
        returnTo: window.location.origin,
      });
    }
  }
}));
